// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
Vue.config.productionTip = false
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)
import { Picker } from 'vant';
Vue.use(Picker);
let instance = axios.create({
    baseURL: 'https://api-beijing.top10fp.com/',
    // baseURL: 'http://192.168.8.55:83/',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('competition_cookie')
    },
})


import './assets/reset.css'

Vue.prototype.$http = instance
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js